import { Layout } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Outlet } from "react-router";
import { Kiosk } from "../../API";
import { useAppSelector } from "../../app/hooks";
import { selectPlayer } from "../../features/player/playerSlice";
import {
  selectTheme,
  setMode,
  setShowPinForm,
  showLoginPopup,
  ThemeColor,
  ThemeMode,
} from "../../features/theme/themeSlice";
import HeaderLinks from "../WelcomeLayout/components/HeaderLinks";
import LoginFormPopup from "../WelcomeLayout/components/LoginFormPopup";
import Logo from "../WelcomeLayout/components/Logo";
import LoggedControls from "../WelcomeLayout2/components/LoggedControls";
import HeaderIcons from "./components/HeaderIcons";

const { Content, Footer, Sider, Header } = Layout;

const KioskLayout = () => {
  const [kioskData, setKioskData] = useState<Kiosk | null>(null);
  const theme = useAppSelector(selectTheme);
  const player = useAppSelector(selectPlayer);
  const dispatch = useDispatch();
  const [clicked, setClicked] = useState<number>(0);
  useEffect(() => {
    dispatch(setMode(ThemeMode.KIOSK));
  }, []);

  useEffect(() => {
    if (clicked === 3) {
      dispatch(setShowPinForm(true));
    }
  }, [clicked]);

  return (
    <Layout
      className={`kiosk fullwidth ${
        theme.theme === ThemeColor.dark ? "d-dark" : "d-light"
      }`}
    >
      <Header className="header-kiosk">
        <div className="d-logo hcol">
          <Logo
            onClick={() => {
              console.log("clicked", clicked);
              setClicked(clicked + 1);
            }}
          />
        </div>

        <div className="d-flex f-right f-row header-right-icons">
          {player.logged && <LoggedControls player={player} />}
          <HeaderLinks />
        </div>
      </Header>
      <Content>
        <Outlet />
      </Content>
      <LoginFormPopup
        visible={theme.showLoginPopup}
        onClose={() => {
          dispatch(showLoginPopup(false));
        }}
        onLoginSuccess={() => {
          dispatch(showLoginPopup(false));
        }}
      />
    </Layout>
  );
};

export default KioskLayout;
